<template>
    <v-container fluid>
        <v-form
            ref="form"
            v-model="validForm"
            lazy-validation
        >
            <v-row>
                <v-col 
                    style="display: flex; align-content: center; align-items: center;"
                    cols="12"
                    lg="12"
                    md="12"
                    sm="12"
                >
                    <h3>Email Template</h3>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <hr />
                </v-col>
            </v-row>
            <v-row>
                <v-col
                    cols="12"
                    lg="4"
                    md="6"
                    sm="12"
                >
                    <label>Template</label>
                    <v-combobox
                        v-model="templateEmailRequest.templateSelected"
                        :items="listTemplateTypes"
                        item-text="description"
                        item-value="id"
                        :rules="[validations.required]"
                        clearable
                        single-line
                        outlined
                        dense
                    ></v-combobox>
                </v-col>
                <v-col
                    cols="12"
                    lg="4"
                    md="6"
                    sm="12"
                >
                    <label>Subject</label>
                    <v-text-field
                        v-model="templateEmailRequest.subject"
                        :rules="[validations.required]"
                        single-line
                        outlined
                        dense
                    ></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col
                    cols="12"
                >
                    <label>Description</label>
                    <v-textarea
                        v-model="templateEmailRequest.description"
                        :rules="[validations.required]"
                        outlined
                        dense
                        rows="15"
                    ></v-textarea>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <v-expansion-panels flat>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="pa-0" style="min-height: 36px;">
                                <span style="font-size: 13px; color: #018388; font-weight: 600;">
                                    <v-icon small color="#018388" class="mr-1">mdi-information-outline</v-icon>
                                    Available Parameters
                                </span>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-simple-table dense class="parameters-legend">
                                    <thead>
                                        <tr>
                                            <th>Parameter</th>
                                            <th>Description</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="param in templateParameters" :key="param.key">
                                            <td><code>{{ param.key }}</code></td>
                                            <td>{{ param.description }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>

            <ActionButtons
                :request="templateEmailRequest"
                :loading="loading"
                :showButtons="{
                    cancel: true,
                    save: true
                }"
                @cancel="cancel"
                @save="save"
            />
        </v-form>
    </v-container>
</template>

<script>
import { required } from "@/utilities/Rules";
import Helpers from '@/utilities/Helpers';
import ActionButtons from "@/components/Layout/ActionButtons";

export default ({
    mixins: [Helpers],

    components: {
        ActionButtons
    },

    data: () => ({
        validForm: true,

        templateEmailRequest: {
            id: 0,
            template: null,
            templateSelected: null,
            subject: "",
            description: ""
        },

        listTemplateTypes: [],
        loading: false,

        validations: {
            required: required,
        },

        templateParameters: [
            { key: '{fullCustomerName}',                description: 'Full customer name (e.g. Smith, John)' },
            { key: '{firstCustomerName}',               description: 'First name of the customer (e.g. John)' },
            { key: '{scheduledDate}',                   description: 'Appointment date (e.g. 04/15/2025)' },
            { key: '{scheduledTime}',                   description: 'Appointment time (e.g. 10:00 AM)' },
            { key: '{appointmentAddress}',              description: 'Address of the scheduled appointment' },
            { key: '{city}',                            description: 'City of the scheduled appointment' },
            { key: '{address}',                         description: 'Customer\'s home address with city' },
            { key: '{customerPhone}',                   description: 'Customer phone number' },
            { key: '{customerEmail}',                   description: 'Customer email address' },
            { key: '{userResponsibleFirstName}',        description: 'First name of the user responsible' },
            { key: '{userResponsibleLastName}',         description: 'Last name of the user responsible' },
            { key: '{userResponsibleEmail}',            description: 'Email of the user responsible' },
            { key: '{userResponsiblePhone}',            description: 'Phone number of the user responsible' },
            { key: '{vankirkInsta}',                    description: 'Van Kirk Instagram URL' },
            { key: '{vankirkFace}',                     description: 'Van Kirk Facebook URL' },
            { key: '{companyName}',                     description: 'Company Name' },
        ]
    }),

    props: {
        id: {
            default: 0
        }
    },

    methods: {
        async getTemplateTypes() {
            let types = await this.$store.dispatch("templateEmailModule/ListTemplateType");
            if (Array.isArray(types)) {
                this.listTemplateTypes = types;
            }
        },

        async getRegister() {
            if (this.id != 0) {
                const response = await this.$store.dispatch("templateEmailModule/GetById", this.id);
                if (response && response.success) {
                    this.templateEmailRequest = response.result;
                }
            }
        },

        cancel() {
            this.$router.push({ path: "/admin/templateEmailList" });
        },

        async save() {
            await this.$refs.form.validate();

            if (this.validForm === false) {
                this.showToast("error", "Warning!", "There are inconsistencies in the form. Please review!");
                return false;
            }
            else {
                this.loading = true;
                this.showLoading();

                this.templateEmailRequest.id = this.id;

                if (this.templateEmailRequest.templateSelected != null && this.templateEmailRequest.templateSelected != undefined) {
                    this.templateEmailRequest.template = this.templateEmailRequest.templateSelected.id;
                }

                const result = await this.$store.dispatch("templateEmailModule/CreateUpdate", this.templateEmailRequest);

                if (result && result.success === true) {
                    this.showToast("success", "Success", result.message);
                    this.cancel();
                }

                this.loading = false;
                this.hideLoading();
            }
        }
    },

    async created() {
        await this.getTemplateTypes();
        await this.getRegister();
    }
});
</script>

<style scoped>
.parameters-legend code {
    background-color: #f0f0f0;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    color: #018388;
}
</style>